import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import LocationDropDown from '../../../../containers/ProjectsContainer/ProjectHierarchy/SubHeader/LocationDropDown';
import Home from '../../../Home';
import TrashIcon from '../../../../components/Iconoclast/TrashIcon';
import dataModel from '../../../../models/DataModel';
import animator from '../../../../helpers/animator';

import './LocationHeader.scss';

var slideInTime = 100;

export class LocationHeader extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();
    this.animate = false;
    this.currentDropDownSize = 290;
    this.closeOtherAndOpenNewDropDown = this.closeOtherAndOpenNewDropDown.bind(this);
    this.queryDeleteLocation = this.queryDeleteLocation.bind(this);
    this.doDeleteLocation = this.doDeleteLocation.bind(this);
    this.state = { 
      selectedUser: null, 
      displayDropDown: '', 
    };
    this.cachedDropDownDisplay = '';
  }

  componentDidMount() {
    super.componentDidMount();
    this.setState({ displayDropDown: '' });
  }

  handleMapRequest() {
    const { displayDropDown } = this.state;
    if (this.props.handleExpansion){
      if (displayDropDown != '') {
        this.closeOtherAndOpenNewDropDown('mapDisplay', 290, true);
      }
      else {
        this.openNewDropDown('mapDisplay', 290, true);
      }
    }
  }

  handleCloseDropdown(e) {
    if(this.props.handleExpansion){
      switch (this.state.displayDropDown) {
      case 'mapDisplay':
        this.handleMapRequest();
        break;
      default:
        break;
      }
      this.props.handleExpansion(0);
    }
  }

  openNewDropDown(displayDropDown, size, animate) {
    if(displayDropDown == 'mapDisplay'){
      this.props.handleExpansion(290);
    }
    else if(displayDropDown == 'commentsDisplay'){
      this.props.handleExpansion(150);
    }
    this.currentDropDownSize = size;
    this.setState({ displayDropDown: displayDropDown });
    this.animate = true;
  }

  closeOtherAndOpenNewDropDown(newDisplayDropDown, newSize, animate) {
    let _this = this;
    if (animate) {
      const animatorGroup = [];

      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(0, animatorGroup, slideInTime);
      }
      const { displayDropDown } = _this.state;
      if (displayDropDown) {
        this.cachedDropDownDisplay = null;
        let ani = _this.animator.createPropertyAnimation(displayDropDown, slideInTime,
          { height: { startVal: this.currentDropDownSize, endVal: 0 } });
        animatorGroup.push(ani);
      }
      if (animatorGroup.length > 0){
        _this.animator.addCollection(animatorGroup, false);
        setTimeout(function() {
          _this.animator.processAnimationQueue(() => {
            const { handleExpand } = _this.props;
            if (handleExpand) {
              handleExpand(0);
            }
            // Dont reopen the new one
            if (newDisplayDropDown != displayDropDown) {
              _this.openNewDropDown(newDisplayDropDown, newSize, animate);
            }
            else {
              _this.setState({ displayDropDown: '' });
              _this.props.handleExpansion(0);
            }
          });
        }, 10);
      }
    }
  }

  doDeleteLocation() {
    // Get anyone but this one
    if (this.props.deleteLocation) {
      this.props.deleteLocation(this.props.editLocation);
    }
  }

  queryDeleteLocation() {
    const message = this.textMap.locationArchiveQuestion;

    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      height: 250,
      message: message, 
      cancelButtonText: this.textMap.cancel, 
      okButtonText: this.textMap.deleteLocation,
      handleOwnerOk: () => {
        this.doDeleteLocation();
      }, 
    });
  }

  createMapDisplay(animate) {
    const { editLocation } = this.props;
    const locationDropDown = <LocationDropDown 
      location={editLocation} 
      height={animate ? 0 : 290} 
      handleCloseDropDown={this.handleCloseDropdown}
    />;

    if (!animate) {
      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(290);
      }
    }
    else {
      this.animateMe('mapDisplay', 290, true);
    }

    return locationDropDown;
  }

  animateMe(id, finalHeight, expandContainer) {
    this.animating = true;
    const animationGroup = [];
    if (expandContainer) {
      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(finalHeight, animationGroup, slideInTime * 2 / 3);
      }
    }
    let ani = this.animator.createPropertyAnimation(id, slideInTime * 2/3, { height: { startVal: 0, endVal: finalHeight } });
    animationGroup.push(ani);
    this.animator.addCollection(animationGroup, false);
    let _this = this;
    setTimeout(function() {
      _this.animator.processAnimationQueue(() => {
        _this.animating = false;
        if (expandContainer) {
          const { handleExpand } = _this.props;
          if (handleExpand) {
            handleExpand(finalHeight);
          }
        }
        else {
          this.hoverDownHasDisplayed = true;
        }
      });
    }, 30);
  }

  handleStartLoader(){
    this.setState({ loader: true });
  }

  handleEndLoader(){
    this.setState({ loader: false });
  }

  render() {

    const { editLocation, closeMap, changed, editing } = this.props;
    const { displayDropDown } = this.state;

    let dropDown = null;

    let mapClasses = 'button map-button';
    if(closeMap){
      this.handleCloseDropdown();
      this.props.closeDropdown();
    }
    else{
      switch (displayDropDown) {
      case 'mapDisplay':
        mapClasses += ' selected';
        dropDown = this.createMapDisplay(this.animate);
        break;
      default:
        break;
      }
    }

    let waitSpinner = null;
    if (this.state.loader) {
      waitSpinner = <Home type="transparent" />;
    }

    let map = (
        <div className={mapClasses} onClick={this.handleMapRequest}>
          <div className="button-label">{this.textMap.map.toUpperCase()}</div>
        </div>
      );

    let editActions = null;
    if (this.props.permissions.canEditLocation) {
      let saveButton = <div className='save-button disabled'>{this.textMap.save}</div>;
      let cancelButton = <div className="cancel-button" onClick={this.props.handleCancelLocationEdit} />;
      let deleteButton = null;
      if (!editLocation.projects_count && !editLocation.builds_count) {
        deleteButton = <div className="delete-button" onClick={this.queryDeleteLocation}>
          <TrashIcon />
        </div>;
      }

      if(changed && editing){
        saveButton = <div className='save-button' onClick={this.props.handleSaveLocation}>{this.textMap.save}</div>;
      }
      editActions = (
        <div className='edit-actions'>
          {saveButton}
          {cancelButton}
          {deleteButton}
        </div>
      );
    }

    return (
      <div id="location-header" className="location-header">
        <div className='row'>
          <div className="location-info">
            <div className="location-identity">
              <div className="location-name">
                {editLocation ? editLocation.name : 'All Projects '}
              </div>
              <div className="guid">
                {editLocation && editLocation.guid ? 'ID: ' + editLocation.guid : ''}
              </div>
            </div>
          </div>
          <div className="location-actions">
            <div className='action-buttons'>
              {map}
              {editActions}
            </div>
          </div>
        </div>
        <div className='row'>
          {dropDown}
        </div>
        {waitSpinner}
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default withRouter(connect(mapStateToProps)(LocationHeader));



// WEBPACK FOOTER //
// ./src/containers/PORContainer/LocationCRUD/LocationHeader/index.js